import { ESide } from '@insolution/core-data-access';
import { getTranslationKeyFromDatabaseProperty } from '../change-case';
import { ISummaryField, ISummaryFieldGroup, ISummaryFieldKeyGroup } from './interfaces/summary-field.interface';

const keysOfTypeEnum = [
  'finishing_by',
  'infill',
  'production_method',
  'profile_b_foot_type',
  'scan_type',
  'side',
  'top_cover_color',
];

export function getSummaryFields<T>(
  groupedFormFieldKeys: ISummaryFieldKeyGroup<T, ISummaryField>[],
  source: T
): ISummaryFieldGroup[] {
  const groups: ISummaryFieldGroup[] = [];

  groupedFormFieldKeys.forEach((group) => {
    const fields: ISummaryField[] = [];

    Object.values(group.keys).forEach((key) => {
      let displayKey = key as unknown as string;

      if ((key as unknown as string).includes('_left') || (key as unknown as string).includes('_right')) {
        displayKey = (key as unknown as string).replace('_left', '').replace('_right', '');

        if (!fields.find((field) => field.key === getTranslationKeyFromDatabaseProperty(displayKey))) {
          const leftValue = source[`${displayKey}_left` as keyof T];
          const rightValue = source[`${displayKey}_right` as keyof T];

          if (leftValue || rightValue) {
            const fieldValues: ISummaryField[] = [];

            fieldValues.push({
              key: ESide.Left,
              value: leftValue as string,
              type: typeof leftValue === 'boolean' ? 'boolean' : keysOfTypeEnum.includes(displayKey) ? 'enum' : 'text',
            });
            fieldValues.push({
              key: ESide.Right,
              value: rightValue as string,
              type: typeof rightValue === 'boolean' ? 'boolean' : keysOfTypeEnum.includes(displayKey) ? 'enum' : 'text',
            });

            if (fieldValues.length) {
              fields.push({
                key: getTranslationKeyFromDatabaseProperty(displayKey),
                value: fieldValues,
                type: keysOfTypeEnum.includes(displayKey) ? 'enumSideValues' : 'sideValues',
              });
            }
          }
        }
      } else if (source[key as keyof T] instanceof Array) {
        const arrayValues = source[key as keyof T] as unknown[];
        if (arrayValues.length) {
          const fieldValues: ISummaryField[] = arrayValues.map((item, index) => {
            return {
              key: `${displayKey} ${index + 1}`,
              value: Object.entries(item as ISummaryField)
                .filter(([key]) => key !== '__typename')
                .map(([key, value]) => ({
                  key: getTranslationKeyFromDatabaseProperty(key),
                  value,
                  type: typeof value === 'boolean' ? 'boolean' : 'text',
                })),
              type: 'text',
            };
          });
          fields.push({
            key: getTranslationKeyFromDatabaseProperty(displayKey),
            value: fieldValues,
            type: 'array',
          });
        }
      } else {
        if (
          typeof source[key as keyof T] === 'boolean' &&
          (source[key as keyof T] || source[key as keyof T] === false)
        ) {
          fields.push({
            key: getTranslationKeyFromDatabaseProperty(displayKey),
            value: source[key as keyof T] as boolean,
            type: 'boolean',
          });
        } else if ((key as unknown as string) === 'evaluation_date' && source[key as keyof T]) {
          fields.push({
            key: getTranslationKeyFromDatabaseProperty(displayKey),
            value: source[key as keyof T] as string,
            type: 'date',
          });
        } else if (keysOfTypeEnum.includes(key as unknown as string) && source[key as keyof T]) {
          fields.push({
            key: getTranslationKeyFromDatabaseProperty(displayKey),
            value: source[key as keyof T] as string,
            type: 'enum',
          });
        } else if (source[key as keyof T] || source[key as keyof T] === 0) {
          fields.push({
            key: getTranslationKeyFromDatabaseProperty(displayKey),
            value: source[key as keyof T] as string | number,
            type: 'text',
          });
        }
      }
    });

    groups.push({
      label: group.label,
      fields,
    });
  });

  return groups;
}
